import { useEffect } from "react"
import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { isNativePlatform } from "../utils/device.util";
import { compareVersions } from "compare-versions"
import { getContentByUrl, getPresignedUrl } from "../utils/common.util";
// import { sendNotification } from "../utils/notification.util";

const useLiveUpdate = () => {

    useEffect(() => {
        checkLiveUpdates()
        const interval = setInterval(() => {
            checkLiveUpdates();
        }, import.meta.env.APP_ENV === 'prod' ? 3600000 : 300000);    //~ Check for updates every 1 hour on production, and every 5 minutes for other environments.

        return () => clearInterval(interval);
    }, [])

    const checkLiveUpdates = async () => {
        try {
            if (!(await isNativePlatform())) return
            if (import.meta.env.APP_ENV === 'development') return
            console.log(`🙈 Checking Live Update 🙈`);

            const url = await getPresignedUrl(`Application/${import.meta.env.APP_ENV}/packages/latest-native.json`)
            const latestNative = await getContentByUrl(url);
            const appVersion = await LiveUpdate.getVersionName()
            const existingBundles = await LiveUpdate.getBundles();
            const isBundleAlreadyDownloaded = existingBundles.bundleIds?.includes(latestNative.version);

            if (compareVersions(latestNative.version, appVersion.versionName) === 1 && !isBundleAlreadyDownloaded) {
                console.log(`🙈 Live Update Start 🙈`);
                const bundleUrl = await getPresignedUrl(`Application/${import.meta.env.APP_ENV}/packages/${latestNative.url}`)

                // sendNotification({
                //     title: 'New update',
                //     body: 'New update is in process',
                // })

                await LiveUpdate.downloadBundle({
                    url: bundleUrl,
                    bundleId: latestNative.version,
                    artifactType: 'zip',
                    checksum: latestNative.sha256
                });


                await LiveUpdate.setNextBundle({ bundleId: latestNative.version });

                for (const bundle of existingBundles?.bundleIds) {
                    if (bundle !== latestNative.version) {
                        await LiveUpdate.deleteBundle({ bundleId: bundle });
                    }
                }
                await LiveUpdate.reload();

                console.log(`🙈 Live Update Successfully 🙈`);
            } else {
                console.log(`🙈 No Live Update Available 🙈`);
            }
        } catch (error) {
            console.error(`🙈  useLiveUpdate.js:58 ~ error : `, error)
        }
    }

}

export default useLiveUpdate